<template>
    <div>
        <v-app>
            <v-dialog :value="dialogStatus" @input="changeDialog" hide-overlay scrollable
                max-width="600px">
                <v-form lazy-validation @submit.prevent="confirm">
                    <v-card class="window-card">
                        <v-card-title>
                            <span class="md-title" style="color: #67ad5b">场景详细信息</span>
                        </v-card-title>
                        <v-card-text>
                            <v-tabs v-model="tab" color="white" background-color="green accent-4" dark
                                style="padding-bottom: 30px">
                                <v-tab key="tab-base">基础属性<v-btn icon>
                                        <!-- <v-icon>mdi-branding_watermark</v-icon> -->
                                    </v-btn>
                                </v-tab>
                                <!-- <v-tab key="tab-ext">扩展属性</v-tab> -->
                                <v-tab key="tab-act">动作定义
                                    <!-- <v-icon>mdi-motion_photos_auto</v-icon> -->
                                </v-tab>
                            </v-tabs>
                            <v-tabs-items v-model="tab">
                                <v-tab-item key="tab-base">
                                    <BaseTab ref="tab-base" />
                                </v-tab-item>
                                <!-- <v-tab-item key="tab-ext">
                                    <ExtTab ref="tab-ext" :extDataList="extDataList" @confirm="actConfirm" @remove="actRemove" />
                                </v-tab-item> -->
                                <v-tab-item key="tab-act">
                                    <ActTab ref="tab-act" :extDataList="extDataList" />
                                </v-tab-item>
                            </v-tabs-items>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="success" type="submit" @click="confirm">确 定</v-btn>
                            <v-btn color="success" @click="cancel">关 闭</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
            </v-dialog>
        </v-app>
    </div>
</template>
<script>
import ActTab from './DeviceDetailDialogTab/ActTab'
import BaseTab from './DeviceDetailDialogTab/BaseTab'
import ExtTab from './DeviceDetailDialogTab/ExtTab'
import { saveDiviceType } from '@/api/device'

export default {
    props: {
        showDialog: {
            type: Boolean,
            default: false
        },
        sceneId: {
            type: String,
            default: ''
        },
        typeData: {
            type: Object,
            default: () => undefined
        }
    },
    components: {
        ActTab,
        BaseTab,
        ExtTab
    },
    data() {
        return {
            tab: 'tab-base',
            basicPropertyMap: {},
            showAddAction: false,
            showActDialog: false,
            extDataList: []
        }
    },
    computed: {
        dialogStatus: {
            get(val) {
                if (val && this.typeData) {
                    this.$nextTick(() => {
                        this.$refs['tab-base'].init(this.typeData)
                        this.$refs['tab-act'].init(this.typeData.actions)
                        this.extDataList = this.typeData.extended_properties ? this.typeData.extended_properties : []
                    })
                }
                return this.showDialog;
            }
        }
    },
    methods: {
        changeDialog(val) {
            this.$emit('update:showDialog', val)
        },
        actConfirm(e) {
            if (e.id) {
                const updateItemIndex = this.extDataList.findIndex((item) => item.id === e.id)
                this.extDataList[updateItemIndex] = e
            } else {
                e.id = `ext_${new Date().getTime()}`
                this.extDataList.push(e)
            }
        },
        actRemove(index) {
            this.extDataList.splice(index, 1)
        },
        confirm() {
            // 保存
            let form = {}
            Object.assign(form, this.$refs['tab-base'].basicPropertyMap)
            form.extended_properties = this.extDataList
            form.actions = this.$refs['tab-act'].actions
            const sceneId = this.sceneId
            form.sceneId = sceneId
            form.type = 'scene'

            saveDiviceType(form).then((res) => {
                if (res.code == 200) {
                    this.$emit('handleConfirm', {
                        form: res.data,
                        isUpdate: form.id !== undefined
                    })
                } else {
                    this.$notify({
                        timeout: 1500,
                        message: res.message,
                        horizontalAlign: "center",
                        verticalAlign: "bottom",
                        type: "warning",
                    });
                }
            })
        },
        cancel() {
            this.$emit('handleCancel', {})
        }
    }
}
</script>
<style>

</style>